import { createAction } from '@reduxjs/toolkit';

import type {
  CreateStopKeywordsPayload,
  DeleteStopKeywordPayload,
  UpdateStopKeywordsPayload,
} from '@polyai/stream/commands/handlers/stop-keywords';

// Store-specific type with flat regularExpressions array
type UpdateStopKeywordsStorePayload = Omit<
  UpdateStopKeywordsPayload,
  'regularExpressions'
> & {
  regularExpressions?: string[];
};

const PREFIX = 'stopKeywords';

const createStopKeywords = createAction<CreateStopKeywordsPayload>(
  `${PREFIX}/createStopKeywords`,
);

const updateStopKeywords = createAction<UpdateStopKeywordsStorePayload>(
  `${PREFIX}/updateStopKeywords`,
);

const deleteStopKeywords = createAction<DeleteStopKeywordPayload>(
  `${PREFIX}/deleteStopKeywords`,
);

export { createStopKeywords, deleteStopKeywords, updateStopKeywords };
